import { render, staticRenderFns } from "./BaseEmpty.vue?vue&type=template&id=c65f97d6&"
import script from "./BaseEmpty.vue?vue&type=script&lang=js&"
export * from "./BaseEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports